(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.hlifeReady === 'true') return;
    root.dataset.hlifeReady = 'true';

    var params = new URLSearchParams(window.location.search);
    if (params.get('hlifeai') === 'chat') {
      root.classList.add('hlife-progressive--chat-mode');
      var chatInput = root.querySelector('[data-hlife-ai-question-input]');
      if (chatInput) {
        window.setTimeout(function () {
          chatInput.focus({ preventScroll: true });
        }, 120);
      }
      return;
    }

    var branches = Array.prototype.slice.call(
      root.querySelectorAll('.hlife-progressive__branch')
    );

    branches.forEach(function (branch) {
      branch.addEventListener('toggle', function () {
        if (!branch.open) return;
        branches.forEach(function (other) {
          if (other !== branch) other.open = false;
        });
      });
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-hlife-progressive]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
